import FinanceiroLegacy from "./FinanceiroLegacy";
import Financial from "./Financial/index";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export default function Financeiro(props) {
  const customer = useSelector(
      state => state.subscription.customer
    );

  const isJussubClient = useMemo(() => !!customer?.external_id, [
    customer?.external_id,
  ]);
  
  useMemo(() => !!customer?.external_id, [
      customer?.external_id,
    ]);

  return isJussubClient ? (
    <Financial {...props} />
  ) : (
    <FinanceiroLegacy {...props} />
  );
}
